export interface IType {
  id: any;
  name: string;
  description: string;
}

export class NamedType<T> implements IType {
  constructor() {}

  id: T = null;
  name: string = null;
  description: string = null;

  public static Create<T>(id: T, name: string, description: string = null) {
    const e = new NamedType<T>();
    e.id = id;
    e.name = name;
    e.description = description;
    return e;
  }
}
